<template>
  <div class="home">
    <div class="banner">
      <div v-if="banner.length">
        <div>
          <div v-for="(item, index) of banner" :key="index">
            <div class="item">
              <a
                :href="banLinks[index] ? banLinks[index] : 'javascript:;'"
                class="img"
              >
                <img :src="imageUrl + item" alt="" />
              </a>
            </div>
          </div>
        </div>
        <!-- Add Pagination -->
        <div class="swiper-pagination swiper-pagination-ban"></div>
      </div>
    </div>

    <div class="row-a2" v-if="serviceShow">
      <div class="wp">
        <div class="moral-title">
          <b>商业道德准则</b>
        </div>
        <div class="g-titb1">
          <div class="p lang_en" v-html="result && result.serviceText">
            <!-- {{ result && result.serviceText }} -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import 'swiper/dist/css/swiper.css';
import Swiper from 'swiper';
import countTo from 'vue-count-to';
import { Loading } from 'element-ui';
let swiper;
export default {
  name: 'Home',
  components: {
    countTo,
  },
  data() {
    return {
      loading: true,
      lang: 'zh',
      result: null,
      banner: [],
      banLinks: [],
      achievementShow: 1, //成就显示开关
      serviceCarousels: [],
      serviceFields: [],
      serviceCarouselTitles: [],
      serviceCarouselTexts: [],
      aboutUsLink: '', //关于我们链接
      outTeamLink: '', //团队链接
      achievementLink: '', //成就链接

      contactShow: 1,
      serviceShow: 1,
      contactAddrLink: [],
      contactEmailLink: [],
      contactPhoneLink: [],

      pageInfo: {
        zhId: '',
        enId: '1547517685983883266',
      },
    };
  },
  mounted() {
    $('body').on('click', '.img_nav li', function () {
      let idx = $(this).index();
      $('.img_nav li').removeClass('active').eq(idx).addClass('active');
      swiper.slideToLoop(idx, 1000, false);
    });
  },

  created() {
    let that = this;
    /* let lang = localStorage.getItem("locale") || 'zh';
    that.lang = lang;
    that.$i18n.locale = lang; */
    Loading.service();
    /* if (that.$i18n.locale === 'zh') {
      that.getHome(that.pageInfo.zhId);
    } else if (that.$i18n.locale === 'en') {
      that.getHome(that.pageInfo.enId);
    } */
    that.getMoralInfo(that.pageInfo.enId);
  },
  watch: {
    /* '$i18n.locale' (newValue) {
      Loading.service();
      let that = this;
      if (that.$i18n.locale === 'zh') {
        that.getHome(that.pageInfo.zhId);
        that.lang = 'zh'
      } else if (that.$i18n.locale === 'en') {
        that.getHome(that.pageInfo.enId);
        that.lang = 'en'
      }
    }, */
    $route: 'setLocal',
  },

  methods: {
    // banner轮播初始化
    initSwiper() {
      swiper = new Swiper('.m-swiperb1 .swiper-container', {
        slidesPerView: 2.1,
        centeredSlides: true,
        loop: true,
        autoplay: true,
        speed: 800,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination1',
          clickable: true,
        },
        on: {
          init: function (swiper) {
            let idx = this.realIndex;
            $('.img_nav li').eq(idx).addClass('active');
          },
          slideChangeTransitionStart: function () {
            // alert(this.activeIndex);
            let idx = this.realIndex;
            $('.img_nav li').removeClass('active').eq(idx).addClass('active');
          },
        },
        breakpoints: {
          960: {
            slidesPerView: 1,
            centeredSlides: false,
          },
          1024: {
            slidesPerView: 2,
          },
        },
      });
    },
    // 服务轮播初始化
    initSwiper1() {
      new Swiper('.banner .swiper-container', {
        slidesPerView: 1,
        autoplay: true,
        speed: 800,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination-ban',
          clickable: true,
        },
      });
    },
    getMoralInfo(id) {
      let that = this;
      let data = {
        id: id,
      };
      that.$http
        .getMoralInfo(data)
        .then((res) => {
          if (res.code == 200) {
            let result = res.result;
            that.result = result;
            // banner
            that.banner = result.carousels ? result.carousels.split(',') : [];
            that.banLinks = result.carouselTitles
              ? result.carouselTitles.split('\n')
              : [];
            // 成就模块是否显示
            that.achievementShow = result.achievementShow;
            that.aboutUsLink = result.aboutUsLink;
            that.outTeamLink = result.outTeamLink;
            that.achievementLink = result.achievementLink;
            // 服务轮播
            that.serviceCarousels = result.serviceCarousels
              ? result.serviceCarousels.split(',')
              : [];
            that.serviceFields = result.serviceFields
              ? result.serviceFields.split('\n')
              : [];
            that.serviceCarouselTitles = result.serviceCarouselTitles
              ? result.serviceCarouselTitles.split('\n')
              : [];
            that.serviceCarouselTexts = result.serviceCarouselTexts
              ? result.serviceCarouselTexts.split('\n')
              : [];

            // 联系
            that.contactAddrLink = result.contactAddrLink
              ? result.contactAddrLink.split('@')
              : [];
            that.contactEmailLink = result.contactEmailLink
              ? result.contactEmailLink.split('@')
              : [];
            that.contactPhoneLink = result.contactPhoneLink
              ? result.contactPhoneLink.split('@')
              : [];
            //联系是否显示
            that.contactShow = result.contactShow;
            //服务是否显示
            that.serviceShow = result.serviceShow;
            that.$nextTick(function () {
              that.initSwiper();
              that.initSwiper1();
            });
            Loading.service().close();
          } else {
            Loading.service().close();
          }
        })
        .catch((err) => {
          that.$message({
            message: err,
            type: 'error',
          });
        });
    },

    // 进入首页，将服务id设置为默认第一个
    setLocal() {
      let path = this.$route.path,
        serid;
      if (path == '/') {
        this.$store.state.navlist.map((item) => {
          if (item.name.toLowerCase() == 'service') {
            for (let i = 0; i < item.sub.length; i++) {
              if (item.sub[i].show) {
                serid = item.sub[i].cid;
                break;
              }
            }
          }
        });
        this.$store.commit('changeServiceId', serid);
        localStorage.setItem('serId', serid);
      }
    },
  },
};
</script>

<style scoped>
.moral-title b {
  font-size: 30px;
  border-bottom: 3px solid #ff0000;
  padding-bottom: 15px;
  color: #002060;
}
</style>
